import 'alpinejs';

window.chooseCoordinates = function data() {
    return {
        div: {
            ['@click'](event) {
                let image = document.getElementById("poc-add-voucher");

                let rect = image.getBoundingClientRect();

                let offset = {
                    top: rect.top + window.scrollY,
                    left: rect.left + window.scrollX,
                };

                let x = Math.floor((event.pageX - offset.left) / image.offsetWidth * 10000) / 100;
                let y = Math.floor((event.pageY - offset.top) / image.offsetHeight * 10000) / 100;

                this.$wire.addCoordinates(x, y);
            }
        }
    }
}

window.chooseCoordinatesCustomer = function data() {
    return {
        div: {
            ['@click'](event) {
                let image = document.getElementById("poc-add-customer");

                let rect = image.getBoundingClientRect();

                let offset = {
                    top: rect.top + window.scrollY,
                    left: rect.left + window.scrollX,
                };

                let x = Math.floor((event.pageX - offset.left) / image.offsetWidth * 10000) / 100;
                let y = Math.floor((event.pageY - offset.top) / image.offsetHeight * 10000) / 100;

                this.$wire.addCoordinatesCustomer(x, y);
            }
        }
    }
}
// end detect position on click on image

window.initAlpine = function data() {
    return {
        isSideMenuOpen: false,
        toggleSideMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen
        },
        closeSideMenu() {
            this.isSideMenuOpen = false
        },
        isNotificationsMenuOpen: false,
        toggleNotificationsMenu() {
            this.isNotificationsMenuOpen = !this.isNotificationsMenuOpen
        },
        closeNotificationsMenu() {
            this.isNotificationsMenuOpen = false
        },
        isProfileMenuOpen: false,
        toggleProfileMenu() {
            this.isProfileMenuOpen = !this.isProfileMenuOpen
        },
        closeProfileMenu() {
            this.isProfileMenuOpen = false
        },
        isPagesMenuOpen: false,
        togglePagesMenu() {
            this.isPagesMenuOpen = !this.isPagesMenuOpen
        },
        // Modal
        isModalOpen: false,
        trapCleanup: null,
        openModal() {
            this.isModalOpen = true
            this.trapCleanup = focusTrap(document.querySelector('#modal'))
        },
        closeModal() {
            this.isModalOpen = false
            this.trapCleanup()
        },
    }
}
